// 쿠키 관리를 위한 유틸리티 함수들
export const cookieUtils = {
    // 쿠키 읽기
    getCookie: (name) => {
        if (typeof document === 'undefined') return null; // SSR 환경 대응
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) {
            const cookieValue = decodeURIComponent(parts.pop().split(';').shift());
            return cookieValue;
        }
        console.log(`[getCookie] 쿠키를 찾을 수 없음: ${name}`);
        return null;
    },
    
    // 쿠키 설정
    setCookie: (name, value, options = {}) => {
        if (typeof document === 'undefined') return; // SSR 환경 대응
        const {
            days = 14,
            path = '/',
            domain = '',
            secure = false,
            sameSite = 'Strict',
            httpOnly = false
        } = options;
        
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        const expires = `expires=${date.toUTCString()}`;
        
        let cookieOptions = [
            `${expires}`,
            `path=${path}`
        ];
        
        if (domain) cookieOptions.push(`domain=${domain}`);
        if (sameSite) cookieOptions.push(`SameSite=${sameSite}`);
        if (secure) cookieOptions.push('Secure');
        if (httpOnly) cookieOptions.push('HttpOnly');
        
        const cookieString = `${name}=${encodeURIComponent(value)}; ${cookieOptions.join('; ')}`;
        document.cookie = cookieString;
    },
    
    // 쿠키 삭제
    deleteCookie: (name, options = {}) => {
        if (typeof document === 'undefined') return; // SSR 환경 대응
        
        const { path = '/', domain = '' } = options;
        
        let cookieOptions = [
            'expires=Thu, 01 Jan 1970 00:00:00 UTC',
            `path=${path}`
        ];
        
        if (domain) cookieOptions.push(`domain=${domain}`);
        
        const cookieString = `${name}=; ${cookieOptions.join('; ')}`;
        document.cookie = cookieString;
        
        console.log(`쿠키 삭제됨: ${name}`);
    }
};